import React, { useContext } from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import StorefrontIcon from "@mui/icons-material/Storefront";
import BadgeIcon from "@mui/icons-material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Link } from "react-router-dom";
import { CartContext } from "../../context/CartContext";

const HeaderIcons = ({ user, role, dashboardRoute }) => {
  const { cartCount } = useContext(CartContext);

  return (
    <>
      {user && (
        <Tooltip title="Dashboard">
          <IconButton component={Link} to={dashboardRoute} color="inherit">
            <DashboardIcon />
          </IconButton>
        </Tooltip>
      )}

      {role === "admin" && (
        <>
          <IconButton component={Link} to="/register/admin" color="inherit">
            <AdminPanelSettingsIcon />
          </IconButton>
          <IconButton component={Link} to="/register/vendor" color="inherit">
            <StorefrontIcon />
          </IconButton>
          <IconButton component={Link} to="/register/agent" color="inherit">
            <BadgeIcon />
          </IconButton>
        </>
      )}

      {role === "customer" && (
        <IconButton component={Link} to="/cart" color="inherit">
          <ShoppingCartIcon />
          {cartCount > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                bgcolor: "red",
                color: "#fff",
                borderRadius: "50%",
                px: 0.6,
                fontSize: 11,
              }}
            >
              {cartCount}
            </Box>
          )}
        </IconButton>
      )}
    </>
  );
};

export default HeaderIcons;